var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.411765%,30.196078%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 83.625 540.039062 L 35.476562 0.0195312 L 564.523438 0.0195312 L 516.335938 539.960938 L 299.664062 600 Z M 83.625 540.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,39.607843%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 475.070312 505.574219 L 516.261719 44.175781 L 300 44.175781 L 300 554.117188 Z M 475.070312 505.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 299.773438 110.398438 L 133.914062 110.398438 L 151.78125 310.6875 L 300 310.6875 L 300 244.460938 L 212.363281 244.460938 L 206.304688 176.644531 L 300 176.644531 L 300 110.398438 Z M 300 416.25 L 299.71875 416.324219 L 225.957031 396.414062 L 221.269531 343.59375 L 154.742188 343.59375 L 164.023438 447.582031 L 299.699219 485.082031 L 300 484.988281 Z M 300 416.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 299.773438 310.6875 L 381.335938 310.6875 L 373.835938 396.5625 L 299.960938 416.492188 L 299.960938 485.398438 L 435.75 447.769531 L 453.9375 244.425781 L 300 244.425781 Z M 464.101562 128.175781 L 465.675781 110.398438 L 299.738281 110.398438 L 299.738281 176.625 L 459.710938 176.625 L 461.023438 161.738281 Z M 464.101562 128.175781 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.e664cf0f69aba286c6a3956a73fcdbb6.svg";
export { ForwardRef as ReactComponent };